module.exports = __webpack_public_path__ + "88932dadc42e1bba93b21a76de60ef7a.ttf";